import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux"
import { useHistory } from "react-router-dom"
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

import api from "../../../service/api";
import { ownerBranchs } from "../../../redux/actions/branchs";

import { Container, Row } from "react-bootstrap";

import Header from "../../../components/Header";
import Table from "../../../components/Table";

import Main from "../../../components/Main/index";
import SideContainer from "../../../components/SideContainer/styles";
import SideForm from "../../../components/SideForm";
import Input from "../../../components/Input/index";
import Button from "../../../components/Button/index";
import DropdownButton from "../../../components/DropdownButton";
import Modal from "../../../components/ModalSuccessMessage";
import ModalClientsDetail from "../../../components/ModalClientsDetail";
import NavTabs from "../../../components/NavTabs";
import Select from "../../../components/Select";
import Animation from "../../../components/Animation/animation";

import { Legend, THead, Th, ThFilterable, Td, FormRadioButton, FormRadioButtonContainer, FormRadioButtonContent, InputWithHintContainer } from "./styles";

import routes from "../../../routes/clients.routes";

import { provisionalData } from "../../../data/provisionalData";

import Person from "../../../assets/icons/manHover.svg";
import upArrow from "../../../assets/icons/chevron-up.svg";
import downArrow from "../../../assets/icons/chevron-down.svg";
import search from "../../../assets/icons/search.svg";
import hint from "../../../assets/icons/hint.svg";
import { translateStatus } from "../../../utils/translate/status";

const Sellers = () => {
  const [isAddFormVisible, setIsAddFormVisible] = useState(false);
  const [isEditFormVisible, setIsEditFormVisible] = useState(false);
  const [typeAccount, setTypeAccount] = useState(0);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [selected, setSelected] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const login = useSelector((state: {login: any}) => state.login);
  const owner = useSelector((state: {branchs: any}) => state.branchs);
  const dispatch = useDispatch();

  const history = useHistory();

  useEffect(() => {
    if(login.user.groups.am3a1){
      history.push("/admin/dashboard");
    }
  }, []);

  useEffect(() => {
    setIsLoading(true)
    const getBranchsAtApiOrRedux = async () => {
      if(owner.branchs.length === 0){
        const { data } = await api.get("/adm/owner100pay/list", {
          params: {
            id: login.user.owners.id
          }
        });

        dispatch(ownerBranchs(data.Branch));
      } else {
        // let onlyBranchs = owner.branchs.slice(1);
        let numberOfPages = owner.branchs.length / 10;

        if(owner.branchs.length % 10 !== 0){
          numberOfPages++;
        }
    
        setMaxPage(Math.floor(numberOfPages));
        setIsLoading(false)
      }
  
    }

    getBranchsAtApiOrRedux();
  }, [owner.branchs]);

  const openAddForm = () => {
    if (isEditFormVisible !== true) {
      setIsAddFormVisible(true);
    }
  };

  const openEditForm = () => {
    if (isAddFormVisible !== true) {
      setIsEditFormVisible(true);
    }
  };

  const tableContentGenerator = () => {
    // let onlyBranchs = owner.branchs.slice(1);
    return owner.branchs.map((branch: any, index: number) => {
      if(index < page*10 && index >= (page * 10) - 10){
        return(
          <tr key={branch.id} style={{ height: 67 }}>
            <Td>{branch.id}</Td>
            <Td>{branch.businessName}</Td>
            <Td>{translateStatus(branch.status)}</Td>
            <Td>{branch.taxpayerIdBranch}</Td>
            <Td>{branch.statementDescriptor}</Td>
            <Td><DropdownButton selectedUser={branch} setSelectedUser={setSelected} isViewOptionVisible={true} openModal={true} modalId="#details-plans"/></Td>
          </tr>
        )
      }
    });
  };

  const formValidationWithYup = Yup.object().shape({
    document: Yup.string().required(),
    email: Yup.string().required(),
    name: Yup.string().required(),
    birthday: Yup.string().required(),
    phoneNumber: Yup.string().required(),
    postalCode: Yup.string().required(),
    city: Yup.string().required(),
    state: Yup.string().required(),
    address: Yup.string().required(),
    neighborhood: Yup.string().required(),
    addressNumber: Yup.string().required(),
    complement: Yup.string().required(),
    bankAgency: Yup.string().required(),
    bankAgencyDigit: Yup.string().required(),
    bankAccount: Yup.string().required(),
    bankHolderName: Yup.string().required()
  })

  const openForm = isAddFormVisible || isEditFormVisible;

  return (
    <Container fluid >
      <Row>
        <Modal text="Adicionado com Sucesso" />
        {<ModalClientsDetail title="Informações do vendedor" type="sellers" data={selected}/>}
        <Main
          className={` ${openForm ? "col-d-none column-side-open" : "column-content"}`}
          isFormVisible={isAddFormVisible}
        >
          <Header
            title="Clientes"
            subTitle="Visualize e gerencie toda a sua base de clientes em um só lugar"
            subTitleWidth={229}
          />

          <NavTabs tabs={routes}/>

          <Table
            buttonText="Adicionar Vendedor"
            isAddFormVisible={isAddFormVisible}
            setIsAddFormVisible={openAddForm}
            showAddButton={login.user.groups.am3a1c}
            showExportButton={login.user.groups.am3a1e}
            page={page}
            setPage={setPage}
            maximumPage={maxPage}
          >
            <THead>
              <tr>
                <ThFilterable>
                  <div>ID</div>
                  <div style={{ marginLeft: 3, lineHeight: 0.7 }}>
                    <img src={upArrow} alt="seta para cima" />
                    <br />
                    <img src={downArrow} alt="seta para baixo" />
                  </div>
                </ThFilterable>
                <Th>Vendedor</Th>
                <ThFilterable>
                  <div>Status</div>
                  <div style={{ marginLeft: 3, lineHeight: 0.7 }}>
                    <img src={upArrow} alt="seta para cima" />
                    <br />
                    <img src={downArrow} alt="seta para baixo" />
                  </div>
                </ThFilterable>
                <Th>Ein</Th>
                <Th>Mcc</Th>
                <Th></Th>
              </tr>
            </THead>
            {
              isLoading 
              ? <Animation/>
              : <tbody>
                  { tableContentGenerator() }
              </tbody>
            }
          </Table>
        </Main>

        <SideContainer visible={isAddFormVisible} className="column-side">
          <SideForm
            title="Adicionar Vendedor"
            icon={Person}
            visible={() => setIsAddFormVisible(false)}
          >
            <Formik
              initialValues={{
                document: "",
                email: "",
                name: "",
                birthday: "",
                phoneNumber: "",
                postalCode: "",
                city: "",
                state: "",
                address: "",
                neighborhood: "",
                addressNumber: "",
                complement: "",
                bankAgency: "",
                bankAgencyDigit: "",
                bankAccount: "",
                bankHolderName: ""
              }}
              validationSchema={formValidationWithYup}
              onSubmit={() => {}}
            >
              {({}) => {
                return(
                  <Form style={{ width: "100%", marginTop: 41 }} id="form">
                    <div className="inputWithIcon">
                      <Input placeholder="Plano" className="inputCustom"/>
                      <img src={search} alt="Procurar"/>
                    </div>
                    <fieldset>
                      <Legend>Cadastro</Legend>
                      <Field id="document" name="document" className="inputCustom" placeholder="CPF/CNPJ" as={Input}/>
                      <Field id="email" name="email" className="inputCustom" placeholder="Email" as={Input}/>
                      <Field id="name" name="name" className="inputCustom" placeholder="Nome Completo" as={Input}/>
                      <Field id="birthday" name="birthday" className="inputCustom" placeholder="Data de nascimento" as={Input}/>
                      <Select>
                          <option>Categoria do negócio</option>
                      </Select>
                      <Field id="phoneNumber" name="phoneNumber" className="inputCustom" placeholder="Telefone" as={Input}/>
                    </fieldset>
                    <fieldset>
                      <Legend>Endereço</Legend>
                      <Field id="postalCode" name="postalCode" className="inputCustom" placeholder="CEP" as={Input}/>
                      <Field id="city" name="city" className="inputCustom" placeholder="Cidade" as={Input}/>
                      <Field id="state" name="state" className="inputCustom" placeholder="UF" as={Input}/>
                      <Field id="address" name="address" className="inputCustom" placeholder="Endereço" as={Input}/>
                      <Field id="neighborhood" name="neighborhood" className="inputCustom" placeholder="Bairro" as={Input}/>
                      <Field id="addressNumber" name="addressNumber" className="inputCustom" placeholder="Número" as={Input}/>
                      <Field id="complement" name="complement" className="inputCustom" placeholder="Complemento" as={Input}/>
                    </fieldset>
                    <fieldset>
                        <Legend>Selecione o tipo de conta</Legend>
                        <div className="d-flex mb-3">
                            <FormRadioButtonContainer onClick={() => setTypeAccount(1)}>
                                <FormRadioButton>
                                    <FormRadioButtonContent isPrimary={ typeAccount === 1 }/>
                                </FormRadioButton>
                                <span>Conta Corrente</span>
                            </FormRadioButtonContainer>

                            <FormRadioButtonContainer onClick={() => setTypeAccount(2)}>
                                <FormRadioButton>
                                    <FormRadioButtonContent isPrimary={ typeAccount === 2 }/>
                                </FormRadioButton>
                                Conta Poupança
                            </FormRadioButtonContainer>
                        </div>
                        <Select>
                            <option>Selecione o Banco</option>
                        </Select>
                        <div className="row">
                            <div className="col-8">
                                <Field id="bankAgency" name="bankAgency" className="inputCustom" placeholder="Agência" as={Input}/>
                            </div>
                            <div className="col-4" style={{paddingLeft: 0}}>
                                <Field id="bankAgencyDigit" name="bankAgencyDigit" className="inputCustom" placeholder="Dígito" as={Input}/>
                            </div>
                        </div>
                        <Field id="bankAccount" name="bankAccount" className="inputCustom" placeholder="Conta"  as={Input}/>
                        <Field id="bankHolderName" name="bankHolderName" className="inputCustom" placeholder="Nome do Titular" as={Input}/>
                        <InputWithHintContainer>
                            <Field value="56.432.673/0001-19" disabled as={Input}/>
                            <img src={hint} alt="Dica" style={{marginLeft: 3}}/>
                        </InputWithHintContainer>
                    </fieldset>
                    <Button
                      className="buttonCustom"
                      data-toggle="modal"
                      data-target="#exampleModal"
                    >
                      Adicionar
                    </Button>
                  </Form>
                )
              }}
            </Formik>
          </SideForm>
        </SideContainer>
      </Row>
    </Container>
  )
}

export default Sellers;